import React from "react";

export const GrainOverlay = () => {
    return <div className="grain-overlay" data-testid="grain-overlay" aria-hidden="true" />;
};
